/**
 * The per-ticket booking fee configured on a ticket type, or 0 when it has none.
 */
export default function getTicketFeeAmount(ticketType) {
  const amount = Number(ticketType?.feeAmount);
  return amount > 0 ? amount : 0;
}
